import * as Constants from './constants'

export const startDragCellConstant = (prefix: string) => `${prefix}_${Constants.DRAG_CELL_START}`
export const endDragCellConstant = (prefix: string) => `${prefix}_${Constants.DRAG_CELL_END}`
export const reorderDragCellConstant = (prefix: string) => `${prefix}_${Constants.DRAG_CELL_REORDER}`
export const initializeDragCellConstant = (prefix: string) => `${prefix}_${Constants.DRAG_CELL_INITIALIZE}`



// WEBPACK FOOTER //
// ./src/components/drag-cell/utils.ts